import React, { Component } from 'react'
import _ from 'lodash'
import { connect } from 'react-redux'
import { reduxForm, Field } from 'redux-form'
import { openLoader, closeLoader } from '../../../../../../redux-store/loader'
import { closeModal, openModal } from '../../../../../../redux-store/modal'
import PaymentModel from '../../../../../../data/models/payment/payment'
import I18n from '../../../../../../i18n'
import { Segment, Header, Table, Form, Button } from 'semantic-ui-react'
import moment from 'moment'
import { required } from '../../../../../../config/validations';
import CustomInput from '../../../../../components/form/input'

class UserSuscriptions extends Component {
    constructor(props) {
        super(props)

        this.state = {
            suscriptions: [],
            column: 'startDate',
            direction: 'descending',
            originalData: []
        }
    }

    componentDidMount() {

        this.getUserSubscriptions();

    }

    getUserSubscriptions = async () => {

        let message = {
            headerTitle : "Error",
            title : I18n.t('messages.modal.commonError'),
            buttons : [
                
                {
                    text : I18n.t('actions.accept'),
                    callback : () => this.props.closeModal()
                
                }

            ]
        };

        try {

            this.props.openLoader();
            const response = await PaymentModel.getUserSubscriptions(this.props.userid);
            if (response.data) {

                this.setState({ suscriptions: _.orderBy(response.data, ['startDate'], ['desc'] ), originalData: response.data });

            }
            
        } catch (error) {
            
            this.props.closeLoader();
            this.props.openModal(message);

        } finally {

            this.props.closeLoader();

        }

    }

    handleSort = (clickedColumn) => () => {
        
        const { column, direction, originalData } = this.state;
    
        if (column !== clickedColumn) {
          this.setState({
            column: clickedColumn,
            suscriptions: _.orderBy(originalData, [clickedColumn], ['asc']),
            direction: 'ascending',
          })
    
          return
        }
    
        this.setState({
            suscriptions: _.orderBy(originalData, [clickedColumn], [direction === 'ascending' ? 'desc' : 'asc']),
            direction: direction === 'ascending' ? 'descending' : 'ascending',
        });

      }

      handleSubmit = async ({ days, payment } ) => {

        let messageError = {
            headerTitle : "Error",
            title : I18n.t('messages.modal.commonError'),
            buttons : [
                
                {
                    text : I18n.t('actions.accept'),
                    callback : () => this.props.closeModal()
                
                }

            ]
        };

        let messageCorrect = {
            title : I18n.t('messages.modal.subscriptionCreated', { days }),
            buttons : [
                
                {
                    text : I18n.t('actions.accept'),
                    callback : () => this.props.closeModal()
                
                }

            ]
        };


        try {

            this.props.openLoader();
            await PaymentModel.createSuscription(this.props.userid, { days: parseInt(days), payment  });
            this.props.openModal(messageCorrect);
            this.getUserSubscriptions();
            
        } catch (error) {
        
            this.props.closeLoader();
            this.props.openModal(messageError);

        } finally {

            this.props.closeLoader();

        }

      }

    render() {

        const  { suscriptions, column, direction } = this.state;

        return (
            <React.Fragment>
                <Segment>
                    <Header as="h3">{I18n.t('user.info.subscriptionList')}</Header>
                    <Table celled selectable sortable>
                            <Table.Header>
                                <Table.Row>
                                    <Table.HeaderCell onClick={this.handleSort('startDate')} sorted={column === 'startDate' ? direction : null}>{ I18n.t('user.info.startDate') }</Table.HeaderCell>
                                    <Table.HeaderCell onClick={this.handleSort('payment')} sorted={column === 'payment' ? direction : null}>{ I18n.t('user.info.payment') }</Table.HeaderCell>
                                </Table.Row>
                            </Table.Header>
                            <Table.Body>
                            { suscriptions.map(suscription => (
                                <Table.Row key={ suscription._id } >
                                    <Table.Cell>{ moment(suscription.startDate).format('DD/MM/YYYY') }</Table.Cell>
                                    {/* Cuando no esta especificado es Stripe por defecto */}
                                    <Table.Cell>{ suscription?.payment ? suscription.payment : "Stripe" } </Table.Cell>
                                </Table.Row>
                            ))}
                            </Table.Body>
                        </Table>
                </Segment>
                <Segment>
                    <Header as="h3">{I18n.t('user.info.createSubscriptionPremium')}</Header>
                    <Form name="suscriptionsForm" onSubmit={this.props.handleSubmit(this.handleSubmit)}>
                        <Field
                            component={ CustomInput }
                            placeholder={I18n.t('user.info.numberDays')}
                            name="days"
                            inline={true}
                            validate={ [required] }
                            restrictions={ [{ numeric: true }] } 
                        />
                        <Field
                            component={ CustomInput }
                            placeholder={I18n.t('user.info.payment')}
                            name="payment"
                            inline={true}
                            validate={ [required] }
                        />
                        <Form.Field>
                            <Button floated="left" content={I18n.t('user.info.create')} icon='plus' labelPosition='right' size="mini" />
                            <div style={{ clear: "both" }}></div>
                        </Form.Field>
                    </Form>
                </Segment>
            </React.Fragment>
        )
    }
}

export default reduxForm({
    form: 'subscriptionForm',
    touchOnBlur: true,
    touchOnChange: false,
    initialValues: {
        days: 0,
        payment: ''
    }
})(connect(null, { openLoader, closeLoader, closeModal, openModal })(UserSuscriptions));
